import React, { useRef, useState } from "react";
import Header from "./Header";
import { BackgroundImage } from "./BackgroundImage";
import { ValidateEmail, ValidatePassword } from "../utils/validation";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  updateProfile,
} from "firebase/auth";
import { auth } from "../utils/firebase";

const Login = () => {
  const [isSignInForm, setIsSignInForm] = useState(true);
  const [emailError, setEmailError] = useState(null);
  const [passError, setPassError] = useState(null);
  const email = useRef("");
  const password = useRef("");
  const fullname = useRef("");

  const toggleForm = () => {
    setIsSignInForm(!isSignInForm);
  };

  const handleSubmit = (e) => {
    // prevent refresh of page
    e.preventDefault();
    //Validate the input first
    const currEmail = email.current.value;
    const currPass = password.current.value;
    const currName = fullname.current.value;
    const emailErr = ValidateEmail(currEmail);
    const passErr = ValidatePassword(currPass);
    setEmailError(emailErr);
    setPassError(passErr);
    // Return if the email or password not valid
    if (emailErr | passErr) return;
    if (!isSignInForm) {
      // Sign up
      createUserWithEmailAndPassword(auth, currEmail, currPass)
        .then((userCredential) => {
          // Signed up
          const user = userCredential.user;
          // update the profile to add dispaly name
          updateProfile(user, { displayName: currName })
            .then()
            .catch((error) => console.log(error));
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          console.log(errorCode + errorMessage);
        });
    } else {
      // Sign in
      signInWithEmailAndPassword(auth, currEmail, currPass)
        .then((userCredential) => {
          const user = userCredential.user;
          // update the profile to add dispaly name
          updateProfile(user, { displayName: currName })
            .then()
            .catch((error) => console.log(error));
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          console.log(errorCode + errorMessage);
        });
    }
  };

  return (
    <div className="relative h-screen">
      <BackgroundImage />
      <Header />
      <div className="absolute inset-0 z-20">
        <form className="w-2/5 h-fit p-6 mx-auto my-40 min-w-96 bg-black text-white rounded-xl bg-opacity-80">
          <div className="flex flex-col h-full justify-between">
            <div>
              <h1 className="text-4xl my-2 ">
                {isSignInForm ? "Sign In" : "Sign Up"}
              </h1>
              {!isSignInForm && (
                <input
                  name="name"
                  className="my-2 p-2 w-full bg-slate-800"
                  type="text"
                  placeholder="Full Name"
                  ref={fullname}
                />
              )}
              <input
                name="email"
                className="my-2 p-2 w-full bg-slate-800"
                type="text"
                autoComplete="email"
                placeholder="Email Address"
                ref={email}
              />
              <p className=" p-2 w-full text-sm font-mono text-red-500">
                {emailError}
              </p>
              <input
                name="password"
                className="p-2 w-full bg-slate-800"
                type="password"
                placeholder="Password"
                ref={password}
              />
              <p className="p-2 w-full text-sm font-mono text-red-500">
                {passError}
              </p>
            </div>
            <div>
              <button
                className="my-2 p-2 w-full bg-red-600 font-semibold "
                type="submit"
                onClick={(e) => handleSubmit(e)}
              >
                {isSignInForm ? "Sign In" : "Sign Up"}
              </button>
              {isSignInForm ? (
                <p className="my-2 p-2">
                  New to MovieFlix?{" "}
                  <button
                    className="font-bold"
                    type="button"
                    onClick={() => toggleForm()}
                  >
                    Sign up now.
                  </button>
                </p>
              ) : (
                <p className="my-2 p-2">
                  Already registered?{" "}
                  <button
                    className="font-bold"
                    type="button"
                    onClick={() => toggleForm()}
                  >
                    Sign in now.
                  </button>
                </p>
              )}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
